export const apiLogsRoute = {
  path: ":menu/api-logs",
  component: () => import("@/views/api-logs/list/index.vue"),
};
